import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { LeadActionsEffects } from './lead.effects';
import { CommonActionsEffects } from './common.effects';
import { BoardStructureActionsEffects } from './board-structure.effects';
import { ErrorNotificationEffects } from './error.effects';
import { UserAgentEffects } from './agent-manager.effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EffectsModule.forFeature([CommonActionsEffects, BoardStructureActionsEffects, ErrorNotificationEffects]),
  ]
})
export class NotificationsModule { }
